import React from "react";
import NewChatListItem from "./NewChatListItem";

export default function NewChatPanel({
  showAddMessage,
  newChatsRef,
  updatedNewChats,
  userData,
  onBack,
  onSearchChange,
  onNewChatSelect,
}) {
  return (
    <div className={`messaging__add ${showAddMessage ? "messaging__add_show" : ""}`}>
      <div className="messaging__add-top">
        <div onClick={onBack} className="messaging__back">
          <img src="/assets/icons/back-arrow.svg" alt="" />
        </div>
        <p>New chat</p>
      </div>
      <div className="messaging__search">
        <span>
          <img src="/assets/icons/search-m.svg" alt="search" />
        </span>
        <input
          placeholder="Search"
          type="text"
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </div>
      <p className="messaging__add-text">
        Showing only technicians who accepted your job
      </p>
      <div className="messaging__add-chats" ref={newChatsRef}>
        {updatedNewChats?.map((item) => (
          <NewChatListItem
            key={item?.id}
            item={item}
            userData={userData}
            onSelect={onNewChatSelect}
          />
        ))}
      </div>
    </div>
  );
}
